import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import Grid from '../../../components/molecules/Grid';
import styles from './style';
import { useScript } from '../../../utils/hooks';
import { canUseDOM } from '../../../utils/canUseDOM';
import { COMPONENT_NAME } from './locators';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { SOCIAL_SHARE_SCRIPT_URL, LANGUAGE_CODE } from '../../../../constants';
import Typography from '../../../components/atoms/Typography';
import Container from '../../../components/molecules/Container';
import { evalConditionForSocialShare } from '../../../utils/cookie';
import { get } from 'lodash';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { NoSsr } from '@material-ui/core';

const SocialShare = props => {
  const classes = styles();
  const key = { value: getDictionaryText('addThis') };
  const targetClass = { value: getDictionaryText('targetClass') };
  const [showComponent, setShowComponent] = useState(true); // need to revert to false when checked in vaddev
  const isSocialShareAvailable = get(
    props,
    'sitecoreContext.route.fields.isSocialShareAvailable.value',
    ''
  );

  useScript(
    showComponent &&
      isSocialShareAvailable &&
      `${SOCIAL_SHARE_SCRIPT_URL}${key ? key.value : ''}`
  );

  useEffect(() => {
    window.handleSocialShareComponentVisibility = () => {
      setShowComponent(true);
    };
    if (window.GTMLoaded) {
      window.handleSocialShareComponentVisibility();
    }
  }, []);

  if (!(showComponent && isSocialShareAvailable)) {
    return <div id="social-share-component"></div>;
  }
  const language = get(
    props,
    'sitecoreContext.language',
    LANGUAGE_CODE.DEFAULT
  );
  if (evalConditionForSocialShare(language)) {
    return null;
  }

  if (!(key && key.value && targetClass && targetClass.value)) {
    console.error('Socialshare key or class name are not provided.');
    return '';
  }
  if (canUseDOM) {
    window.addthis_config = {};
    window.addthis_config.lang = language;
  }

  return (
    <Container>
      <NoSsr>
        <Grid data-locator={COMPONENT_NAME} className={classes.root}>
          <Grid item xs={12} className={classes.header}>
            <Typography variant="h5Bold" component="h2">
              {getDictionaryText('socialShareHeading')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <div className={targetClass.value}></div>
          </Grid>
        </Grid>
      </NoSsr>
    </Container>
  );
};

SocialShare.propTypes = {
  fields: PropTypes.shape({
    key: PropTypes.object,
  }),
};

SocialShare.defaultProps = {
  fields: PropTypes.shape({
    key: { value: '' },
  }),
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(SocialShare))
);
